import { makeStyles } from "@material-ui/core/styles";
import { OrderState } from "../../pages/OrderDetailsPage/OrderDetailsTypes";
import { DELIVERY_STATUS_UI } from "./deliveryStatus.ui";
import { h7Medium } from "../../shared/typography";

interface StyleProps {
  state: OrderState;
}

export const useStyles = makeStyles({
  root: (props: StyleProps) => {
    const cfg = DELIVERY_STATUS_UI[props.state];

    return {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "2px 8px",
      borderRadius: 12,
      whiteSpace: "nowrap",
      backgroundColor: cfg.backgroundColor,
      color: cfg.textColor,
      border: cfg.borderColor ? `1px solid ${cfg.borderColor}` : "none",
      ...h7Medium,
    };
  },
});
